import React, { Component } from "react";
import { trackReportStyle } from "../../../Reports/Timps/style/index";
import "../../../Reports/Timps/style/style.css";
import { Container, Col, Row, Label, Button, FormGroup } from "reactstrap";
import { themeService } from "../../../../theme/service/activeTheme.service";
import { iconToShow, iconTwoShow } from "../../../Reports/variables";
import _ from "lodash";
import { dataFormatters } from "../../../../utils/dataFormatters";
import { tick_char } from "../special-char";
import moment from "moment";
class LoneWorkerONR extends Component {
  constructor(props) {
    super(props);
    this.config = {
      minRows: 5,
    };

    this.state = {
      data: props.data ? props.data : {},
    };
  }

  render() {
    let { data } = this.state;
    const _date = this.props.MERGED ? data.date1 : data.date;
    const logo1Source = themeService(iconToShow);
    return (
      <React.Fragment>
        <div
          className="table-report job-briefing-ontario safety-watch last-page-break-print"
          style={{ ...themeService(trackReportStyle.mainStyle) }}
        >
          <Row>
            <Col md={2}>{logo1Source && <img src={logo1Source} alt="Logo" style={{ width: "100%" }} />}</Col>
            <Col md={3}></Col>
            <Col md={7}>
              <h2 style={{ ...themeService(trackReportStyle.headingStyle), textAlign: "right", transform: "none" }}>
                <span>{"RAIL INFRASTRUCTURE JOB BRIEFING"}</span>
                <br />
                <span style={{ fontWeight: "100", fontStyle: "italic" }}>{`${this.props.title}`}</span>
              </h2>
            </Col>
          </Row>
          <hr />

          <table className="table-bordered lone-worker">
            <thead>
              <tr>
                <td colSpan={19} className="dark-bg" style={{ textAlign: "center" }}>
                  <span className="main-heading-in-rpt">
                    LONE WORKER <small>(to be completed when applicable)</small>
                  </span>
                </td>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td colSpan={1}>1</td>
                <td colSpan={7}>
                  <span className="text-left d-block pd-left-10px">Name:</span>
                </td>
                <td colSpan={11}>
                  <span style={{ fontWeight: 100 }}>{data.name}</span>
                </td>
              </tr>
              <tr>
                <td colSpan={1}>2</td>
                <td colSpan={7}>
                  <span className="text-left d-block pd-left-10px">Date:</span>
                </td>
                <td colSpan={11}>
                  <span style={{ fontWeight: 100 }}>{_date ? moment(_date).format("MM-DD-YYYY") : ""}</span>
                </td>
              </tr>
              <tr>
                <td colSpan={1}>3</td>
                <td colSpan={7}>
                  <span className="text-left d-block pd-left-10px">Subdivision:</span>
                </td>
                <td colSpan={11}>
                  <span style={{ fontWeight: 100 }}>{data.sub}</span>
                </td>
              </tr>
              <tr>
                <td colSpan={1}>4</td>
                <td colSpan={7}>
                  <span className="text-left d-block pd-left-10px">Working Limits:</span>
                </td>
                <td colSpan={11}>
                  <span style={{ fontWeight: 100 }}>{data.work}</span>
                </td>
              </tr>
              <tr>
                <td colSpan={1}>5</td>
                <td colSpan={7}>
                  <span className="text-left d-block pd-left-10px">Time Limits:</span>
                </td>
                <td colSpan={11}>
                  <span style={{ fontWeight: 100 }}>{data.time}</span>
                </td>
              </tr>
              <tr>
                <td colSpan={1}>6</td>
                <td colSpan={7}>
                  <span className="text-left d-block pd-left-10px">RTC / Foreman / Supervisor Reviewed and Time:</span>
                </td>
                <td colSpan={11}>
                  <span style={{ fontWeight: 100 }}>{data.rfsrt}</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </React.Fragment>
    );
  }
}
export default LoneWorkerONR;



// WEBPACK FOOTER //
// ./src/components/jobBriefing/JobBrieifingReport/Ontario/loneWorker.jsx